import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "toggle-button__container" }
const _hoisted_2 = { class: "toggle-button__part toggle-button__left" }
const _hoisted_3 = { class: "toggle-button__part toggle-button__right" }
const _hoisted_4 = { class: "toggle-button__label" }

import { withDefaults } from "vue";

interface Props {
  label?: string;
  disabled?: boolean;
  checked?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'toggle-button',
  props: {
    label: {},
    disabled: { type: Boolean },
    checked: { type: Boolean }
  },
  emits: ["toggleSwitch"],
  setup(__props: any, { emit }) {

const props = __props;




const toggleSwitch = () => {
  if (props.disabled) return;
  emit("toggleSwitch", !props.checked);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["toggle-button", { 'toggle-button__disabled': props.disabled }]),
    onClick: toggleSwitch
  }, [
    _createElementVNode("a", _hoisted_1, [
      _withDirectives(_createElementVNode("div", _hoisted_2, " OFF ", 512), [
        [_vShow, !props.checked]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_3, " ON ", 512), [
        [_vShow, props.checked]
      ])
    ]),
    _createElementVNode("a", _hoisted_4, _toDisplayString(_ctx.label), 1)
  ], 2))
}
}

})